var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Provider } from '@filou/core';
import Document from '../document';
var renderToSheetList = require('fela-dom').renderToSheetList;
export var createReactStaticConfig = function (config) { return (__assign({ extensions: ['.js', '.jsx', '.ts', '.tsx'], webpack: function (config, _a) {
        var defaultLoaders = _a.defaultLoaders;
        // Add TypeScript Path Mappings (from tsconfig via webpack.config.js)
        // to react-statics alias resolution
        if (Array.isArray(config.entry)) {
            config.entry[config.entry.length - 1] = config.entry[config.entry.length - 1].replace('.js', '.tsx');
        }
        else {
            config.entry = config.entry.replace('.js', '.tsx');
        }
        config.resolve.extensions.push('.ts', '.tsx');
        config.module.rules[0].oneOf[0].test = /\.(js|jsx|ts|tsx)$/;
        config.module.rules[0].oneOf[1].test = /\.(js|jsx|ts|tsx)$/;
        return config;
    }, Document: function (props) { return React.createElement(Document, __assign({}, props)); }, beforeRenderToElement: function (App, _a) {
        var meta = _a.meta;
        meta.renderer = config.createFelaRenderer();
        return function (props) { return (React.createElement(Provider, { renderer: meta.renderer },
            React.createElement(App, __assign({}, props)))); };
    }, renderToHtml: function (render, Comp, _a) {
        var meta = _a.meta;
        var html = render(Comp);
        meta.sheetList = renderToSheetList(meta.renderer);
        return html;
    } }, config)); };
//# sourceMappingURL=index.js.map